import {
  DATA_CONNECTOR_APPWRITE_ENVIRONMENT_BEGIN,
  DATA_CONNECTOR_APPWRITE_ENVIRONMENT_SUCCESS,
  DATA_CONNECTOR_APPWRITE_ENVIRONMENT_FAILURE,
  DATA_CONNECTOR_APPWRITE_ENVIRONMENT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function appwriteEnvironment(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_APPWRITE_ENVIRONMENT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/external-datasource/environments/constants`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITE_ENVIRONMENT_SUCCESS,
            data: res,
          });
          resolve(res);
          console.log('getting response here appwrite variables', res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITE_ENVIRONMENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAppwriteEnvironmentError() {
  return {
    type: DATA_CONNECTOR_APPWRITE_ENVIRONMENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_APPWRITE_ENVIRONMENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        appwriteEnvironmentPending: true,
        appwriteEnvironmentError: null,
      };

    case DATA_CONNECTOR_APPWRITE_ENVIRONMENT_SUCCESS:
      // The request is success
      return {
        ...state,
        appwriteEnvironmentPending: false,
        appwriteEnvironmentError: null,
      };

    case DATA_CONNECTOR_APPWRITE_ENVIRONMENT_FAILURE:
      // The request is failed
      return {
        ...state,
        appwriteEnvironmentPending: false,
        appwriteEnvironmentError: action.data.error,
      };

    case DATA_CONNECTOR_APPWRITE_ENVIRONMENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        appwriteEnvironmentError: null,
      };

    default:
      return state;
  }
}
